import Axios from '../api/axios';
import * as glb from '../globals.js';
import { dispatchLookupUpdated, persistLookupCache } from './lookupStorage';

export const ISLEMSABLON_LKP_EVENT = 'islemsablonLkpUpdated';

function isActiveSablonRow(row) {
    if (!row) return false;
    const v = row.IS_SILINDI ?? row.is_silindi;
    return !(v === true || v === 1 || v === '1' || String(v).toLowerCase() === 't');
}

function buildBaslikFromDetay(detay) {
    const seen = new Set();
    const baslik = [];
    detay.forEach((row) => {
        const key = `${row.IS_TIP}::${row.IS_SATIS_TURU || ''}::${row.IS_AD}`;
        if (!seen.has(key)) {
            seen.add(key);
            baslik.push({ IS_TIP: row.IS_TIP, IS_AD: row.IS_AD, IS_SATIS_TURU: row.IS_SATIS_TURU ?? null });
        }
    });
    return baslik;
}

function upperKeys(row) {
    if (!row || typeof row !== 'object') return row;
    const out = {};
    Object.keys(row).forEach((key) => {
        out[String(key).toUpperCase()] = row[key];
    });
    return out;
}

function normalizeIslemsablonLkp(data) {
    if (!data) return { detay: [], baslik: [] };
    const source = Array.isArray(data) ? data : (Array.isArray(data.detay) ? data.detay : []);
    const detay = source.map(upperKeys).filter(isActiveSablonRow);
    const baslik = buildBaslikFromDetay(detay);
    return { detay, baslik };
}

export function filterIslemSablonBySatisTipi(rows, satisTipi) {
    const tip = Number(satisTipi);
    if (!Number.isFinite(tip) || tip <= 0) return [];
    return (Array.isArray(rows) ? rows : []).filter((row) => Number(row?.IS_TIP) === tip);
}

// IS_SATIS_TURU boşsa şablon o satış tipinin bütün satış türlerine aittir.
// linkedOnly=true yalnızca belirli türe açıkça bağlanmış şablonları bırakır.
export function filterIslemSablonBySatis(rows, satisTipi, satisTuru, linkedOnly = false) {
    return filterIslemSablonBySatisTipi(rows, satisTipi).filter((row) => {
        if (!isActiveSablonRow(row)) return false;
        const tur = Number(row.IS_SATIS_TURU);
        if (!tur) return !linkedOnly;
        return tur > 0 && tur === Number(satisTuru);
    });
}

function foldSablonLabel(value) {
    return String(value ?? '')
        .trim()
        .toLocaleLowerCase('tr-TR')
        .replace(/ı/g, 'i')
        .replace(/\s+/g, ' ');
}

/** Satış türü adına en yakın şablon. Eşleşme yoksa boş döner. */
export function pickSablonForSatisTuru(items, satisTuruAd) {
    const target = foldSablonLabel(satisTuruAd);
    if (!target) return '';
    let bestName = '';
    let bestScore = 0;
    (Array.isArray(items) ? items : []).forEach((row) => {
        const name = String(row?.IS_AD ?? '').trim();
        const folded = foldSablonLabel(name);
        if (!name || !folded) return;
        let score = 0;
        if (folded === target) score = 1000;
        else {
            const short = folded.length <= target.length ? folded : target;
            const long = folded.length <= target.length ? target : folded;
            if (long.startsWith(short)) {
                const rest = long.slice(short.length).trim();
                if (rest === 'i' || rest === 'paket' || rest === 'paketi') score = 800 - rest.length;
            }
        }
        if (score > bestScore) {
            bestScore = score;
            bestName = name;
        }
    });
    return bestName;
}

export function sablonComboItems(rows, satisTipi, satisTuru, showAll = false) {
    const source = showAll
        ? (Array.isArray(rows) ? rows : []).filter(isActiveSablonRow)
        : filterIslemSablonBySatis(rows, satisTipi, satisTuru);
    return [...new Map(source.map((row) => [row.IS_AD, row])).values()];
}

export function sablonLinesByName(rows, sablonName, satisTipi, satisTuru, showAll = false) {
    const name = String(sablonName ?? '');
    if (!name) return [];
    const source = showAll
        ? (Array.isArray(rows) ? rows : []).filter(isActiveSablonRow)
        : filterIslemSablonBySatis(rows, satisTipi, satisTuru);
    return source.filter((row) => row.IS_AD === name);
}

export function shouldOfferSatisSablon(previous, saved) {
    if (!(Number(saved?.CAS_REF) > 0) || !(Number(saved?.CAS_SATIS_TURU) > 0)) return false;
    return !(Number(previous?.CAS_REF) > 0)
        || Number(previous.CAS_TIP) !== Number(saved.CAS_TIP)
        || Number(previous.CAS_SATIS_TURU) !== Number(saved.CAS_SATIS_TURU);
}

export function applyGlobalIslemsablonLkp(data) {
    const lkp = normalizeIslemsablonLkp(data);
    glb.default.islemsablonLkp = lkp;
    persistLookupCache('islemsablonLkp', lkp);
    dispatchLookupUpdated(ISLEMSABLON_LKP_EVENT, {
        detayCount: lkp.detay.length,
        baslikCount: lkp.baslik.length,
    });
    return lkp;
}

export function refreshGlobalIslemsablonLkp() {
    return Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}CARI_SATIS/islemsablon`)
        .then((res) => applyGlobalIslemsablonLkp(res?.data));
}
